import React, { useRef, useState } from 'react';
import { Col, message, Row } from 'antd';
import { useMutation } from '@apollo/react-hooks';
import SINGLE_UPLOAD_MUTATION from 'shared/graphql/mutation/singleUpload';
import { axiosErp } from 'shared/config/axios';
import { getStoredAuthToken } from 'shared/utils/authToken';
import { FilePond, registerPlugin } from 'react-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import { Text } from 'shared/components';
import DocumentList from './DocumentList';

registerPlugin(FilePondPluginFileValidateSize, FilePondPluginFileValidateType);

type CostingOtherDocument = {
  costingId: string;
};

const CostingOtherDocument: React.FC<CostingOtherDocument> = (props) => {
  const { costingId } = props;
  const filePondRef = useRef<any>();
  const [dataCosting, setDataCosting] = useState<any>(null);
  const [singleUpload] = useMutation(SINGLE_UPLOAD_MUTATION, {
    update: (_cache, { data }) => {
      const { path } = data.singleUpload;
      createCostingDocument(path);
    },
  });
  const token = getStoredAuthToken();

  const functionGetData = async () => {
    try {
      const costingData = await axiosErp(token).post(`/costing-document-job-list`, {
        params: {
          delete: false,
          costingJobId: costingId,
        },
      });
      setDataCosting(costingData.data);
    } catch (e) {
      message.error(e.message);
      console.error('ERROR TO LOAD COSTING DETAIL: ', e);
    }
  };

  const createCostingDocument = async (path: string) => {
    try {
      await axiosErp(token).post(`create-costing-document-job`, {
        costingJobId: costingId,
        documentFile: path,
      });

      message.success('เพิ่มไฟล์เอกสารแล้ว');
      functionGetData();
    } catch (err) {
      message.error(err.message);
      console.error('ERROR TO LOAD COSTING DETAIL: ', err);
    }
  };

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          อัพโหลดเอกสารทั่วไป
          <div>
            <Text customType="grey">
              (รูปแบบไฟล์ที่รองรับ .jpg , .jpeg , .png , .pdf , และขนาดไฟล์ไม่เกิน 2Mb.)
            </Text>
          </div>
        </Col>
        <Col span={24}>
          <FilePond
            ref={filePondRef}
            server={{
              process: (_fieldName, file, _metadata, _load, error) => {
                singleUpload({
                  variables: {
                    file,
                  },
                })
                  .then(() => {
                    filePondRef.current.removeFile();
                  })
                  .catch((err) => {
                    message.error(err.message);
                    error(err);
                  });
              },
            }}
            acceptedFileTypes={['image/jpeg', 'image/png', 'application/pdf']}
            maxFileSize="2MB"
          />
        </Col>
      </Row>
      <DocumentList costingId={costingId} dataCosting={dataCosting} />
    </>
  );
};

export default CostingOtherDocument;
